<template>
	<div :class="finalClass" class="icon-button" :title="title" :style="'--app-button-icon-color:'+color" @click="clickListener">
		<div class="btn-inner">
			<img :src="finalIcon" :alt="iconName" v-if="!loading">
			<AppLoader v-if="loading" :size="13" :color="colorLoader" />
		</div>
	</div>
</template>

<script>
import AppLoader from "@/shared/components/AppLoader.vue";
import {useUserStore} from "@/console-new/stores";

export default {
	setup() {
		let userStore = useUserStore();
		return {userStore};
	},
	name: "AppButtonIcon",
	emits: ["click-icon"],
	props: {
		iconName: {type: String, required: true},
		active: {type: Boolean, default: false},
		small: {type: Boolean, default: false},
		preventChange: {type: Boolean, default: false},
		color: {type: String, default: 'var(--color-primary)'},
		colorLoader: {type: String, default: "#fff"},
		loading: {type: Boolean, default: false},
		outline: {type: Boolean, default: false},
		disabled: {type: Boolean, default: false},
		title: {type: String, default: ""},
	},
	components: {AppLoader},
	data() {
		return {
			isActive: this.active,
		};
	},
	methods: {
		clickListener() {
			if (!this.preventChange) {
				this.isActive = !this.isActive;
			}
			this.$emit("click-icon", this.isActive);
		}
	},
	computed: {
		finalClass() {
			let className = this.small ? 'small ' : '';
			className += this.isActive ? 'active' : '';
			className += this.outline ? ' outline' : '';
			className += this.disabled ? ' disabled' : '';
			return className;
		},
		finalIcon() {
			return new URL("https://img.qromo.io/img/icons/" + this.iconName + (this.userStore.darkMode ? '-dark' : '') + ".svg", import.meta.url).href;
		}
	},
	watch: {
		active(newVal) {
			this.isActive = newVal;
		}
	}
};
</script>

<style lang="scss" scoped>
.icon-button {
	@include centered;
	width: 35px;
	height: 35px;
	border-radius: 13px;
	box-shadow: 0 1px 2px var(--color-box-shadow-3);
	background-color: var(--color-bg);
	cursor: pointer;
	transition: opacity .2s $transition;

	&, & * {
		@include noSelect;
	}

	& * {
		pointer-events: none;
	}

	&.active .btn-inner {
		background-color: $secondary;
	}

	.btn-inner {
		@include centered;
		box-shadow: inset 0 2px 3px var(--color-box-shadow-dark-2);
		width: 29px;
		height: 29px;
		border-radius: 10px;
		background-color: var(--app-button-icon-color);
		transition: background-color .2s $transition;

		img {
			max-width: 15px;
			max-height: 15px;
		}
	}

	&.small {
		width: 25px;
		height: 25px;
		border-radius: 50%;

		.btn-inner {
			width: 20px;
			height: 20px;
			border-radius: 50%;

			img {
				max-width: 10px;
				max-height: 10px;
			}
		}

		&.active .btn-inner {
			background-color: var(--color-secondary);
		}
	}

	&.outline {
		background-color: var(--app-button-icon-color);

		.btn-inner {
			background-color: var(--color-bg-primary-2);
		}
	}
}
</style>